import { render } from "./total.vue?vue&type=template&id=e898bc68&scoped=true"
import script from "./total.vue?vue&type=script&lang=js"
export * from "./total.vue?vue&type=script&lang=js"

import "./total.vue?vue&type=style&index=0&id=e898bc68&scoped=true&lang=css"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e898bc68"]])

export default __exports__